import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/home2.webp'
import _imports_1 from '../assets/quotes-grey-top.png'
import _imports_2 from '../assets/quotes-grey-bottom.png'


const _withScopeId = n => (_pushScopeId("data-v-0bbe5b5c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "first scroll-to" }, [
  /*#__PURE__*/_createElementVNode("article", null, [
    /*#__PURE__*/_createElementVNode("hr"),
    /*#__PURE__*/_createElementVNode("div", { class: "title-1" }, "Empowering communities"),
    /*#__PURE__*/_createElementVNode("div", { class: "title-2" }, "by"),
    /*#__PURE__*/_createElementVNode("div", { class: "title-3" }, "tranforming lives"),
    /*#__PURE__*/_createElementVNode("hr")
  ])
], -1))
const _hoisted_2 = { class: "second scroll-to" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("article", null, [
    /*#__PURE__*/_createElementVNode("h2", null, "What we do"),
    /*#__PURE__*/_createElementVNode("span", null, " Love on People is a non-profit organization that adds value to the villages in the province of Colombia by empowering, inspiring and educating women and children affected by violence, poverty and exclusion. ")
  ]),
  /*#__PURE__*/_createElementVNode("figure", null, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: ""
    })
  ])
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "third scroll-to" }, [
  /*#__PURE__*/_createElementVNode("article", null, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_1,
      alt: "quote symbol"
    }),
    /*#__PURE__*/_createTextVNode(" BEING UNWANTED, UNLOVED, UNCARED FOR, FORGOTTEN BY EVERYBODY, I THINK THAT IS A MUCH GREATER HUNGER, A MUCH GREATER POVERTY THAN THE PERSON WHO HAS NOTHING TO EAT. "),
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_2,
      alt: "quote symbol"
    })
  ]),
  /*#__PURE__*/_createElementVNode("span", null, "MOTHER TERESA")
], -1))
const _hoisted_5 = { class: "fourth scroll-to" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ArticleCard = _resolveComponent("ArticleCard")!
  const _component_lp_sticky_button = _resolveComponent("lp-sticky-button")!

  return (_openBlock(), _createElementBlock("main", null, [
    _hoisted_1,
    _createElementVNode("section", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("article", null, [
        _createVNode(_component_router_link, {
          to: "/projects",
          custom: ""
        }, {
          default: _withCtx(({ navigate }) => [
            _createVNode(_component_lp_button, {
              onClick: navigate,
              color: "white",
              size: "x-large"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Learn about our projects")
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        })
      ])
    ]),
    _hoisted_4,
    _createElementVNode("section", _hoisted_5, [
      _createVNode(_component_ArticleCard, {
        image: "home-volunteer-card.webp",
        title: _ctx.volunteerCard.title,
        action: _ctx.volunteerCard.action,
        description: _ctx.volunteerCard.description,
        url: _ctx.volunteerCard.url
      }, null, 8, ["title", "action", "description", "url"]),
      _createVNode(_component_ArticleCard, {
        image: "home-donate-card.webp",
        title: _ctx.donateCard.title,
        action: _ctx.donateCard.action,
        description: _ctx.donateCard.description,
        url: _ctx.donateCard.url
      }, null, 8, ["title", "action", "description", "url"]),
      _createVNode(_component_ArticleCard, {
        image: "home-support-card.webp",
        title: _ctx.supportCard.title,
        action: _ctx.supportCard.action,
        description: _ctx.supportCard.description,
        url: _ctx.supportCard.url
      }, null, 8, ["title", "action", "description", "url"])
    ]),
    _createVNode(_component_lp_sticky_button)
  ]))
}